import { clsx } from "clsx";
import { ReactComponent as InstagramIcon } from "components/icons/social/instagram.svg";
import { ReactComponent as TwitterIcon } from "components/icons/social/twitter.svg";
import { ReactComponent as RedditIcon } from "components/icons/social/reddit.svg";
import { ReactComponent as OnlyfansIcon } from "components/icons/social/onlyfans.svg";
import { ReactComponent as ManyvidsIcon } from "components/icons/social/manyvids.svg";
import { ReactComponent as PatreonIcon } from "components/icons/social/patreon.svg";
import { ReactComponent as PornhubIcon } from "components/icons/social/pornhub.svg";
import { ReactComponent as XhamsterIcon } from "components/icons/social/xhamster.svg";
import { ReactComponent as ChaturbateIcon } from "components/icons/social/chaturbate.svg";
import { ReactComponent as MyfreecamsIcon } from "components/icons/social/myfreecams.svg";
import { ReactComponent as FanslyIcon } from "components/icons/social/fansly.svg";
import { ReactComponent as DefaultIcon } from "components/icons/websiteIcon.svg";
import { ReactComponent as CamsodaIcon } from "components/icons/social/camsoda.svg";
import { ReactComponent as FancentroIcon } from "components/icons/social/fancentro.svg";
import "./style/SocialIcon.scss";

interface ISocialIconProps {
  name: string;
}

export const getIcon = (name: string): any => {
  switch (name) {
  case "twitter": return <TwitterIcon />;
  case "instagram": return <InstagramIcon />;
  case "reddit": return <RedditIcon />;
  case "onlyfans": return <OnlyfansIcon />;
  case "manyvids": return <ManyvidsIcon />;
  case "patreon": return <PatreonIcon />;
  case "pornhub": return <PornhubIcon />;
  case "xhamster": return <XhamsterIcon />;
  case "chaturbate": return <ChaturbateIcon />;
  case "myfreecams": return <MyfreecamsIcon />;
  case "fansly": return <FanslyIcon />;
  case "camsoda": return <CamsodaIcon />;
  case "fancentro": return <FancentroIcon />;
  default: return <DefaultIcon />;
  }
};

export const SocialIcon: React.FC<ISocialIconProps> = (props) => {
  const { name } = props;

  return (
    <span className={clsx("SocialIcon", `SocialIcon_${name}`)}>{getIcon(name)}</span>
  );
};

